<div *ngIf="loading" class="row info company__profile">
  <mat-spinner style="margin-top: 80px; margin-bottom: 80px;" class="api-data-spinner"></mat-spinner>
</div>
<div class="company__profile" [formGroup]="companyForm" *ngIf="!loading">
  <div class="settings d-flex flex-row">
    <mat-icon class="edit-icon" [matMenuTriggerFor]="menu">more_vert</mat-icon>
    <mat-menu xPosition="before" #menu="matMenu">
      <button mat-menu-item (click)="showEdit()">{{ 'PERSONAL_PROFILE.EDIT_PROFILE' | translate }}</button>
    </mat-menu>
  </div>
  <div class="d-flex" style="padding-bottom: 32px;">
    <div class="company__wrapper flex-row">
      <div class="row">
        <div class="col-3">
          <img src="./assets/images/icons/venue-logo-placeholder-01.svg" alt="profile-picture">
        </div>
        <div class="col-9" style="padding-left:4px !important;">
          <h5 class="title">{{ company.companyName }}</h5>
          <div class="company__profile__role">


            <!-- <p>Service and Entertainment</p>  -->
            <a class="user__link" href="{{company.websiteUrl}}" target="_blank">{{company.websiteUrl}}</a>
          </div>
        </div>
      </div>
      <div class="row company__m-32-wrap">
        <div class="row">
          <div *ngIf="enableEdit" class="col-12">
            <label for="companyName">{{ 'LOGIN.COMPANY_NAME' | translate }} *<mat-icon *ngIf="enableEdit"
                class="mat-icon-edit">edit
              </mat-icon>
              <i
                *ngIf="companyForm.controls.companyName?.invalid && (companyForm.controls.companyName?.dirty || companyForm.controls.companyName?.touched)">
                <i *ngIf="companyForm.controls.companyName?.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"
                    style="font-family: 'primeicons'; line-height: normal;" pTooltip="{{ 'INFO.REQUIRED' | translate }}"
                    tooltipStyleClass="test" tooltipPosition="top"></i>
                </i>
              </i>
            </label>
            <input type="text" id="companyName" formControlName="companyName" [value]="company.companyName"
              name="companyName">
          </div>
          <div *ngIf="enableEdit" class="col-12">
            <label for="websiteUrl">{{ 'LOGIN.WEB_SITE' | translate }}<mat-icon *ngIf="enableEdit"
                class="mat-icon-edit">edit
              </mat-icon></label>
            <input type="text" id="websiteUrl" formControlName="websiteUrl" [value]="company.websiteUrl"
              name="websiteUrl">
          </div>
          <!-- <div *ngIf="!enableEdit" class="col-12">
            <label for="general-ratting">{{ 'COMPANY_PROFILE.RATING' | translate }}</label>
            <app-rating></app-rating>
          </div> -->
        </div>
      </div>
    </div>
    <div class="company__wrapper">
      <div class="row company__m-12-wrap">
        <div class="col-6">
          <label for="hqaddress">{{ 'INFO.HQ_ADDRESS' | translate }}
            <i *ngIf="enableEdit">*</i>
            <mat-icon *ngIf="enableEdit" class="mat-icon-edit">
              edit
            </mat-icon>

            <i *ngIf="(errorModel!=null && errorModel['address']!=null) && (companyForm.controls.address.dirty || companyForm.controls.address.touched)">
              <i *ngIf="companyForm.controls.address.errors?.['required'] || (errorModel!=null && errorModel['address']!=null)"
                class="pi pi-exclamation-circle float-end me-1 error_color"
                style="font-family: 'primeicons'; line-height: normal;" pTooltip="{{ 'INFO.HQ_ERROR' | translate }}"
                tooltipPosition="top"></i>
              <!-- <i *ngIf="errorModel!=null && errorModel['address']!=null"
                class="pi pi-exclamation-circle float-end me-1 error_color"
                style="font-family: 'primeicons'; line-height: normal;" pTooltip="{{errorModel['address']|translate}}"
                tooltipPosition="top"></i> -->
            </i>

          </label>
          <input [hidden]="enableEdit" disabled type="text" id="hqaddress" [value]="company.address" name="hqaddress">
          <input [hidden]="!enableEdit" #search autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
            id="address" name="address" placeholder='Type here...' formControlName="address" type="text"
            (input)="changeAddress(companyForm.controls.address.value)" />
        </div>
        <div class="col-6">
          <label *ngIf="!enableEdit" for="businesstype">{{ 'INFO.BUSINESS_TYPE' | translate }}</label>
          <label *ngIf="!enableEdit" class="simple-label">{{companyTypesString}}</label>
          <!-- <input [hidden]="enableEdit" disabled type="text" id="businesstype" [value]="companyTypesString"
            name="businesstype"> -->

          <app-multi-select-dropdown *ngIf="enableEdit" [title]="'INFO.BUSINESS_TYPE'" [list]="list"
            [checkedItems]="typesIds" (shareCheckedList)="shareIndividualCheckedTypeList($event)">
          </app-multi-select-dropdown>
        </div>
      </div>
      <div class="row company__m-32-wrap">
        <div class="col-6">
          <label for="email">{{ 'LOGIN.EMAIL' | translate}}
            <mat-icon *ngIf="enableEdit" class="mat-icon-edit">edit
            </mat-icon>
            <i
              *ngIf="companyForm.controls.email?.invalid && (companyForm.controls.email?.dirty || companyForm.controls.email?.touched)">
              <!-- <i *ngIf="companyForm.controls.email?.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.EMAIL_REQUIRED' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i> -->
              <i *ngIf="companyForm.controls.email?.errors?.['pattern']">
                <i class="pi pi-exclamation-circle float-end me-1 error_color"
                  style="font-family: 'primeicons'; line-height: normal;"
                  pTooltip="{{ 'INFO.INVALID_EMAIL' | translate }}" tooltipStyleClass="test" tooltipPosition="top"></i>
              </i>
            </i>
          </label>
          <input type="text" id="email" formControlName="email" [value]="company.email" name="email">
        </div>
        <div class="col-6">
          <label for="phone">{{ 'LOGIN.PHONE' | translate }} <mat-icon *ngIf="enableEdit" class="mat-icon-edit">edit
            </mat-icon>
            <i
              *ngIf="companyForm.controls.phone?.invalid && (companyForm.controls.phone?.dirty || companyForm.controls.phone?.touched)">
              <!-- <i *ngIf="companyForm.controls.phone?.errors?.['required']">
                  <i class="pi pi-exclamation-circle float-end me-1 error_color"  style="font-family: 'primeicons'; line-height: normal;"
                      pTooltip="{{ 'INFO.REQUIRED' | translate }}" tooltipStyleClass="test"
                      tooltipPosition="top"></i>
              </i> -->
              <i *ngIf="companyForm.controls.phone?.errors?.['pattern']">
                <i class="pi pi-exclamation-circle float-end me-1 error_color"
                  style="font-family: 'primeicons'; line-height: normal;"
                  pTooltip="{{ 'INFO.PHONE_PATTERN' | translate }}" tooltipStyleClass="test" tooltipPosition="top"></i>
              </i>
            </i></label>
          <input type="text" id="phone" formControlName="phone" [value]="company.phone" name="phone">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="enableEdit" class="d-flex flex-row" style="justify-content: space-between; padding-bottom: 32px;">
    <button style="width: 50%; border: none; font-weight: 900; color: white; height: 36px;"
      class="mat-bakcground-primary mat-raised-button"
      [disabled]="companyForm.controls.companyName.invalid || companyForm.controls.email.invalid || companyForm.controls.phone.invalid || typesIds.length == 0 || (errorModel!=null && errorModel['address']!=null)"
      (click)="save()">{{ 'SAVE_CHANGES' | translate }}</button>
    <button style="width: 47%; font-weight: 900; color: white; height: 36px; margin-right: 16px;"
      class="mat-raised-button" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  </div>
</div>

<p-tabView *ngIf="!company.needCompanyUpdate" styleClass="tab-view-panel">
  <p-tabPanel header="{{ 'COMPANY_PROFILE.PAYMENT' | translate }}">
    <app-payment-and-bills></app-payment-and-bills>
  </p-tabPanel>
  <p-tabPanel header="{{ 'COMPANY_PROFILE.STAFF' | translate }}">
    <app-staff-members></app-staff-members>
  </p-tabPanel>
</p-tabView>